module.exports = __webpack_public_path__ + "static/humble-beginings-8aa794a3906207bb42b7738071f15def.jpg";